import { Container, getLocalConfig } from '@hzero-front-ui/core';
import React, { useMemo } from 'react';
import Scheduler from './Scheduler';
var UedContainer = function UedContainer(props) {
  var defaults = useMemo(function () {
    return getLocalConfig();
  }, []);
  return /*#__PURE__*/React.createElement(Container, {
    defaultTheme: defaults.schema
  }, /*#__PURE__*/React.createElement(Scheduler, null), props.children);
};
export default UedContainer;